export default __webpack_public_path__ + "static/media/logoHumane.5e5198a7.svg";